module.exports = __webpack_public_path__ + "media/images/lb/837-049de19b973bc961de492aab9b8fe74d.svg";